import React, { useState, useEffect } from 'react'
import { StakingCard } from '../../components/StakingCard'
import networks from '../../networks.json'
import { CHAIN_ID } from '../../constants'

import {
  PageContainer,
  StakingContainer,
  CardsContainer,
  StakingText,
} from './Staking.styled'
function Staking({ chainId, mrunBalance, userAddress, forceUpdate, forced }) {
  const [metarunStakingContracts, setmetarunStakingContracts] = useState()

  useEffect(() => {
    setmetarunStakingContracts(networks[CHAIN_ID].metarunStakingContracts)
  }, [chainId])

  return (
    <PageContainer>
      <StakingContainer>
        {metarunStakingContracts ? (
          <CardsContainer>
            {metarunStakingContracts.map(
              ({
                address,
                APY,
                name,
                duration,
                tableMrunPerCharacter,
                earnDynamicAPY,
                tableYieldRate,
              }) => (
                <StakingCard
                  key={APY}
                  APY={APY}
                  name={name}
                  contractAddress={address}
                  mrunBalance={mrunBalance}
                  userAddress={userAddress}
                  chainId={chainId}
                  duration={duration}
                  tableMrunPerCharacter={tableMrunPerCharacter}
                  earnDynamicAPY={earnDynamicAPY}
                  tableYieldRate={tableYieldRate}
                  forceUpdate={forceUpdate}
                  forced={forced}
                />
              )
            )}
          </CardsContainer>
        ) : (
          <StakingText>Something went wrong :(</StakingText>
        )}
      </StakingContainer>
    </PageContainer>
  )
}

export default Staking
